import { Component, Mixins } from 'vue-property-decorator';
import Common from './common';
import { Breadcrumbs, Section } from './types';

@Component
export default class PageActivitiesCommon extends Mixins(Common) {
  // Computed
  get breadcrumbSections(): Breadcrumbs {
    const result = [...this.breadcrumbs];

    if (this.sectionRoute) result.push(this.sectionRoute);
    if (this.subsectionRoute) result.push(this.subsectionRoute);

    return result;
  }

  get section() {
    if (this.sectionIndex === -1) return null;
    return this.$store.state.activitySections[this.sectionIndex];
  }

  get sectionIndex() {
    const { section } = this.$route.params;
    if (!section) return -1;
    return this.$store.state.activitySections.findIndex(({ code }: Section) => code === section);
  }

  get sectionRoute() {
    const { routeName, section } = this;
    if (!section) return null;

    return {
      text: section.name,
      to: {
        name: routeName,
        params: {
          section: section.code,
        }
      }
    };
  }

  get subsection() {
    if (this.subsectionIndex === -1) return null;
    return this.section.children[this.subsectionIndex];
  }

  get subsectionIndex() {
    const { section, $route } = this;
    if (!section) return -1;
  
    const { subsection } = $route.params;
    if (!subsection) return -1;

    const { children = [] } = section;
    return children.findIndex(({ code }: Section) => code === subsection);
  }

  get subsectionRoute() {
    const { routeName, section, subsection } = this;
    if (!section || !subsection) return null;

    return {
      text: subsection.name,
      to: {
        name: routeName,
        params: {
          section: section.code,
          subsection: subsection.code,
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/sections.ts